import SocialImage from "./SocialImage";

export { SocialImage };
